import React, { Component } from 'react';
import { InputNumber as AntInput } from 'antd';

class ZIndex extends Component {
  updateInput = (value) => {
    this.props.updateSetting(this.props.settingKey, value);
  }
  render() {
    let MIN_VAL;
    let MAX_VAL;
    if (this.props.settingKey === "inactivityCallback") {
      MIN_VAL = 1;
      MAX_VAL = 86400;
    } else {
      MIN_VAL = -1;
      MAX_VAL = 2147483647;
    }

    return (
      <div className="set-inputnumber">
        <h4>{this.props.settingsTitle}</h4>
        <AntInput style={{width: '100%'}} min={MIN_VAL} max={MAX_VAL} value={this.props.value} onChange={(value) => this.updateInput(value)} />
      </div>
    );
  }
}

export default ZIndex;

